import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { GET, APIImpl } from '../../api';
import { SearchToneBasedOnCodeRequest } from './searchtonebasedoncoderequest';

export class SearchBasedOnCodeToneAPI extends APIImpl<SearchToneBasedOnCodeRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/search-tone
        // return "search-tone"+"?"+"language="+ this.getRequest().getSearchToneRequest().getLanguage()+"&"+
        // "categoryId="+ this.getRequest().getSearchToneRequest().getCategoryId()+"&"+
        // "pageNo="+ this.getRequest().getSearchToneRequest().getPageNo()+"&"+
        // "toneId="+ this.getRequest().getSearchToneRequest().getToneId()+"&"+
        // "pagePerCount="+ this.getRequest().getSearchToneRequest().getPagePerCount();

        let request = "search-tone"+"?"+"language="+ this.getRequest().getSearchToneRequest().getLanguage();

        if(this.getRequest().getSearchToneRequest().getToneId() !== undefined && 
                this.getRequest().getSearchToneRequest().getToneId() !== "")
        {
            request = request + "&" + "toneId="+ this.getRequest().getSearchToneRequest().getToneId();
        }

        if(this.getRequest().getSearchToneRequest().getCategoryId() !== undefined && 
        this.getRequest().getSearchToneRequest().getCategoryId() > 0)
        {
            request = request + "&" + "categoryId="+ this.getRequest().getSearchToneRequest().getCategoryId();
        }

        if(this.getRequest().getSearchToneRequest().getPageNo() !== undefined && 
        this.getRequest().getSearchToneRequest().getPageNo() >= 0)
        {
            request = request + "&" + "pageNo="+ this.getRequest().getSearchToneRequest().getPageNo();
        }

        if(this.getRequest().getSearchToneRequest().getPagePerCount() !== undefined && 
        this.getRequest().getSearchToneRequest().getPagePerCount() >= 0)
        {
            request = request + "&" + "perPageCount="+ this.getRequest().getSearchToneRequest().getPagePerCount();
        }

        return request;
    }

    /* getHttpHeaders():string
    {
        return {
            "language": this.getRequest().getSearchToneRequest().getLanguage(),
               "searchKey": this.getRequest().getSearchToneRequest().getSearchKey(),
               "categoryId": this.getRequest().getSearchToneRequest().getCategoryId(),
               "sortBy": this.getRequest().getSearchToneRequest().getSortBy(),
               "alignBy": this.getRequest().getSearchToneRequest().getAlignBy(),
               "pageNo": this.getRequest().getSearchToneRequest().getPageNo(),
               "searchLanguage": this.getRequest().getSearchToneRequest().getSearchLanguage(),
               "pagePerCount": this.getRequest().getSearchToneRequest().getPagePerCount(),
            "fingerPrint" : "DD:EB:B6:7C:BD:27:AB:D2:9F:98:45:95:C1:65:49:5F:75:98:9E:31:83:5A:3D:E2:81:4B:E9:E3:F1:8B:B3:EC",
            "appId" : "com.sixdee.callertunes_etisalat",
            "appVersion" : "1.0.6",
            "channelId" : "9",
            "versionCode" : "7",
            "os" : "ios",
            "deviceId" : "0191212",
            "notificationTrackingId" : "",
             "accessToken" : this.getContext().getUserContext().getAccessToken()
        } as any;
    } */
    
    getRequestData()
    {
        return ""; /* "language="+ this.getRequest().getSearchToneRequest().getLanguage() +"&"+
               "searchKey="+ this.getRequest().getSearchToneRequest().getSearchKey() +"&"+
               "categoryId="+ this.getRequest().getSearchToneRequest().getCategoryId() +"&"+
               "sortBy="+ this.getRequest().getSearchToneRequest().getSortBy() +"&"+
               "alignBy="+ this.getRequest().getSearchToneRequest().getAlignBy() +"&"+
               "pageNo="+ this.getRequest().getSearchToneRequest().getPageNo() +"&"+
               "searchLanguage="+ this.getRequest().getSearchToneRequest().getSearchLanguage()+"&"+
               "pagePerCount="+ this.getRequest().getSearchToneRequest().getPagePerCount(); */
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/search/searchtonebasedoncode/searchtonebasedoncodeapi.tsx